<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <h2 ngpDialogTitle class="modal-title">
      {{ "link-related-articles.modal.title" | translate }}
    </h2>
    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="onCancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    @if (form) {
      <form [formGroup]="form" class="form-stack">
        <p class="form-hint">
          {{ "link-related-articles.form.description" | translate }}
        </p>

        <div class="form-pair">
          <div class="form-pair__field">
            <label for="min_similarity" sui-label>
              {{ "link-related-articles.form.min-similarity" | translate }}
            </label>
            <sui-input
              id="min_similarity"
              type="number"
              formControlName="min_similarity"
              [min]="1"
              [max]="100"
            ></sui-input>
            @if (
              form.get("min_similarity")?.touched &&
              form.get("min_similarity")?.invalid
            ) {
              <span class="error-text">
                {{ "link-related-articles.form.error.range-1-100" | translate }}
              </span>
            }
          </div>
          <div class="form-pair__field">
            <label for="max_similarity" sui-label>
              {{ "link-related-articles.form.max-similarity" | translate }}
            </label>
            <sui-input
              id="max_similarity"
              type="number"
              formControlName="max_similarity"
              [min]="1"
              [max]="100"
            ></sui-input>
            @if (
              form.get("max_similarity")?.touched &&
              form.get("max_similarity")?.invalid
            ) {
              <span class="error-text">
                {{ "link-related-articles.form.error.range-1-100" | translate }}
              </span>
            }
          </div>
        </div>

        @if (hasSimilarityRangeError()) {
          <span class="error-text">
            {{
              "link-related-articles.form.error.min-greater-than-max"
                | translate
            }}
          </span>
        }

        <div class="form-pair">
          <div class="form-pair__field">
            <label for="results" sui-label>
              {{ "link-related-articles.form.results" | translate }}
            </label>
            <sui-input
              id="results"
              type="number"
              formControlName="results"
              [min]="1"
              [max]="10"
            ></sui-input>
            @if (form.get("results")?.touched && form.get("results")?.invalid) {
              <span class="error-text">
                {{ "link-related-articles.form.error.range-1-10" | translate }}
              </span>
            }
          </div>
        </div>

        <!-- The time range: the period type and its amount, one block of the stack -->
        <div class="time-range">
          <label sui-label>
            {{ "link-related-articles.form.time-range" | translate }}
          </label>

          <sui-button-group
            class="period-type-group"
            stretch
            [options]="periodTypeOptions"
            formControlName="period_type"
          ></sui-button-group>

          <div class="relative-amount">
            <sui-slider
              class="relative-amount__slider"
              [min]="amountMin"
              [max]="amountMax"
              [step]="1"
              formControlName="relative_amount"
            ></sui-slider>
            <span class="relative-amount__value">
              {{
                "link-related-articles.form.relative-amount-prefix" | translate
              }}
              <span class="relative-amount__number">
                {{ form.get("relative_amount")?.value }}
              </span>
              {{
                periodTypeLabelKey(
                  $safeNavigationMigration(form.get("period_type")?.value)
                ) | translate
              }}
            </span>
          </div>
        </div>

        <sui-checkbox formControlName="current_feed_only">
          {{ "link-related-articles.form.current-feed-only" | translate }}
        </sui-checkbox>

        <h4 class="section-heading">
          {{
            "link-related-articles.section.main-article-preferences" | translate
          }}
        </h4>
        <div class="form-pair">
          <div class="form-pair__field">
            <label for="prominence" sui-label>
              {{ "link-related-articles.label.prominence" | translate }}
            </label>
            <sui-select id="prominence" formControlName="prominence">
              @for (option of prominenceOptions; track option.id) {
                <sui-select-option
                  [value]="option.id"
                  [label]="option.labelKey | translate"
                  >{{ option.labelKey | translate }}</sui-select-option
                >
              }
            </sui-select>
          </div>
          <div class="form-pair__field">
            <label for="language_id" sui-label>
              {{ "link-related-articles.label.language" | translate }}
            </label>
            <sui-select id="language_id" formControlName="language_id">
              <sui-select-option
                [value]="null"
                [label]="
                  'link-related-articles.language-option.any-language'
                    | translate
                "
                >{{
                  "link-related-articles.language-option.any-language"
                    | translate
                }}</sui-select-option
              >
              @for (lang of languageOptions; track lang.id) {
                <sui-select-option
                  [value]="lang.id"
                  [label]="lang.name ?? lang.title"
                  >{{ lang.name ?? lang.title }}</sui-select-option
                >
              }
            </sui-select>
          </div>
        </div>

        @if (showSchedule) {
          <app-algorithm-schedule
            [parent]="form"
            [editMode]="editMode"
            [defaultIntervalMinutes]="initialIntervalMinutes"
            [initialRecurrence]="initialRecurrence"
            [initialTimezoneId]="initialTimezoneId"
          ></app-algorithm-schedule>
        }
      </form>
    }
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button variant="secondary" (click)="onCancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button
      variant="primary"
      [leadingIcon]="runButtonIcon()"
      [disabled]="!form?.valid"
      (click)="onSubmit()"
    >
      {{ runButtonText() }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
